import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { MasterData } from '~/components/settings/masterData/MasterData';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata',
    ...routeParams,
  }),
  component: MasterData,
});

export const MASTERDATA = buildRouteExport({ Route, ...routeParams });
